import { Component } from '@angular/core';
import { routes } from '../../shared/routes/routes';

@Component({
  standalone: false,
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss']
})
export class PatientsComponent {
  public routes = routes;

}
